var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "o-mainMenu" + _vm.isActive }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "m-mainMenu__items" }, [
      _c("li", { staticClass: "a-mainMenu__item" }, [
        _c("a", { attrs: { href: "https://www.adoptujkravicku.sk" } }, [
          _vm._v("Domov")
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-mainMenu__item" }, [
        _c(
          "a",
          { attrs: { href: "https://www.adoptujkravicku.sk/ako-adoptovat/" } },
          [_vm._v("Ako adoptovať")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-mainMenu__item" }, [
        _c(
          "a",
          { attrs: { href: "https://www.adoptujkravicku.sk/kravicky/" } },
          [_vm._v("Kravičky")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-mainMenu__item" }, [
        _c(
          "a",
          { attrs: { href: "https://www.adoptujkravicku.sk/o-projekte/" } },
          [_vm._v("O projekte")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-mainMenu__item" }, [
        _c(
          "a",
          { attrs: { href: "https://www.adoptujkravicku.sk/kontakt/" } },
          [_vm._v("Kontakt")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "m-aboutMenu__items" }, [
      _c("li", { staticClass: "a-aboutMenu__item" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.adoptujkravicku.sk/pravidla-pouzivania/"
            }
          },
          [_vm._v("Pravidlá používania")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-aboutMenu__item" }, [
        _c(
          "a",
          { attrs: { href: "https://www.adoptujkravicku.sk/ako-adoptovat/" } },
          [_vm._v("Návody, tipy a triky")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-aboutMenu__item" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.adoptujkravicku.sk/vyrobky-zapojene-do-projektu/"
            }
          },
          [_vm._v("Výrobky zapojené do projektu")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-aboutMenu__item" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.adoptujkravicku.sk/slovenska-mliecna-rodina/"
            }
          },
          [_vm._v("Slovenská mliečna rodina a partneri")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-socialMenu_items" }, [
      _c(
        "a",
        {
          staticClass: "a-socialMenu__item --facebook",
          attrs: { href: "https://www.facebook.com/AdoptujKravicku/" }
        },
        [_c("span", { staticClass: "facebook" })]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "a-socialMenu__item --youtube",
          attrs: {
            href: "https://www.youtube.com/channel/UC3k1Az5Cg7ItiLvg8loJgVQ"
          }
        },
        [_c("span", { staticClass: "youtube" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-copyrightInfo" }, [
      _c("p", [
        _vm._v("© 2019 Slovenská mliečna rodina"),
        _c("br"),
        _vm._v("\n        Vytvorené v "),
        _c("a", { attrs: { href: "https://www.oktodigital.com/" } }, [
          _vm._v("okto.digital")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }